import React, { useState, useEffect } from "react";

// material-ui
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import { Get_limited_From_MongoDB } from "../../../api/Get_limited_From_MongoDB";

import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import getNameByID from "../../../../functions/getNameByID";
import getNestedPropByID from "../../../../functions/getNestedPropByID";
import { Get_All_From_MongoDB } from "../../../api/Get_All_From_MongoDB";
import { StaffuseAuth } from "../../../security/StaffuseAuth";
import SimpleTableHeader from "../../../components/Tables/SimpleTableHeader";
import { Get_EC_Attendees_From_MongoDB } from "./api/Get_EC_Attendees_From_MongoDB";
import { Get_ECs_From_Attendee_IDs } from "./api/Get_ECs_From_Attendee_IDs";
import { Get_Agencies_From_EC_IDs } from "./api/Get_Agencies_From_EC_IDs";
import SimpleTableCell from "../../../components/Tables/SimpleTableCell";
import { Get_Invoices_From_Attendee_IDs } from "./api/Get_Invoices_From_Attendee_IDs";
import { POST_FlipECValue } from "./api/POST_FlipECValue";

function EndOfYearStaffView() {
  const { logout } = StaffuseAuth();

  //-----------------------------Get Data---------------------------------------------

//--------------Get Attendees
  const [Attendees, setAttendees] = useState([]);
  useEffect(() => {
    Get_EC_Attendees_From_MongoDB(setAttendees, logout);
  }, []);


  //--------------Get ECs
  const EC_IDs = Attendees.map((Attendee) => Attendee.IPInfo?.EC_ID);
  const [ECs, setECs] = useState([]);
useEffect(() => {
    if (EC_IDs.length > 0) {
        Get_ECs_From_Attendee_IDs(EC_IDs, setECs, logout);
    }
}, [JSON.stringify(EC_IDs)]);


//--------------Get Agencies
const Agencies_IDs = ECs.map((EC) => EC.MetaData?.Agency_id);
const uniqueAgencies_IDs = [...new Set(Agencies_IDs)];
  const [Agencies, setAgencies] = useState([]);
  useEffect(() => {
    Get_Agencies_From_EC_IDs(uniqueAgencies_IDs, setAgencies, logout);
  }, [JSON.stringify(uniqueAgencies_IDs)]);


  //--------------Get Invoices Paid
  const [Invoices, setInvoices] = useState([]);
    const Attendee_IDs = Attendees.map((Attendee) => Attendee._id);
    const uniqueAttendee_IDs = [...new Set(Attendee_IDs)];
  useEffect(() => {
    Get_Invoices_From_Attendee_IDs(uniqueAttendee_IDs, setInvoices, logout);
  }, [JSON.stringify(uniqueAttendee_IDs)]);


  //--------------Functions

  //Given an EC id, find all Attendees and then all Invoices
  const findAttendeesByECId = (ecId) => {
    const attendeesForEC = Attendees.filter((attendee) => attendee.IPInfo?.EC_ID === ecId);
    return attendeesForEC
  };

    //Given an array of attendees, where each has a value in OrderInfo.LineItemPrice and OrderInfo.LineItemDiscount, display the total line item price minus total line item discount
  const displayTotalLineItemPrice = (attendees) => {
    let Total =0
    attendees.forEach((attendee) => {
        Total += Number(attendee.OrderInfo?.LineItemPrice || 0) - Number(attendee.OrderInfo?.LineItemDiscount || 0)
    })
return Total  ;
  }



  //Given an array of attendees, find sum the value of SubAmount in the Attendees array, where the value of Attendee_id is in the array attendees
  const sumSubAmountByAttendeeIDs = (attendees, GrossOrNet) => {
    const attendeeIDs = attendees.map((attendee) => attendee._id);
    let totalSubAmount = 0;
    Invoices.filter((Invoice) => Invoice.GrossOrNet === GrossOrNet).forEach((invoice) => {
      invoice.Attendees.forEach((attendee) => {
        if (attendeeIDs.includes(attendee.Attendee_id)) {
          totalSubAmount += Number(attendee.SubAmount || 0);
        }
      });
    });
    return totalSubAmount;
  };

  //Buttons

  const handleCommission2025Click = (ID, Value, prop) => {
    //Change the value of that EC to either Yes or No for the prop

    POST_FlipECValue(ID,Value==="Yes" ? "No": "Yes" ,prop,logout)
    //handleCommission2025Click
    const updatedECs = ECs.map((EC) => {
      if (EC._id === ID) {
        return {
          ...EC,
          MetaData: {
            ...EC.MetaData,
            [prop]: Value === "Yes" ? "No" : "Yes",
          },
        };
      }
      return EC;
    });
    setECs(updatedECs);
  };

     
  //-----------------------------Return--------------------------------------------

  return (
    <div style={{ backgroundColor: "#e5e5e5", minHeight: "93vh" }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row", // Add this line
          flexWrap: "wrap",
          justifyContent: "flex-start",
          // gap: "20px",
          // height: "100%",
        }}
      >
        <div
          name="space"
          style={{ width: "100%", height: "10px", flex: "0 1 auto" }}
        ></div>
       {/*  <SearchBar setECs={setECs} /> */}
        <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        maxWidth: "95%",
        maxHeight: "800px",
        flexGrow: 1,
        p: 1,
      }}
    >
      <Typography variant="h6" gutterBottom>
        View EC's
      </Typography>
      <TableContainer
        component={Paper}
        sx={{
          width: "100%",
          margin: "0 auto",
          overflow: "auto",
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            border: "1px solid #e0e0e0",
            tableLayout: "fixed",
          }}
        >
          <TableHead>
            <TableRow>
            {SimpleTableHeader("Agency / Agent")}
            {SimpleTableHeader("ACcount Name")}
            {SimpleTableHeader("Email")}
            {SimpleTableHeader("Shopify")}
            {SimpleTableHeader("Net Inv")}
            {SimpleTableHeader("Gross Inv")}
            {SimpleTableHeader("Commission Calc")}
            {SimpleTableHeader("Commission")}
            {SimpleTableHeader("Amount Approved")}
            {SimpleTableHeader("Sent to Finance")}
            {SimpleTableHeader("Confirmed by Finance")}

            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(169, 169, 169, 0.8)", // Dark grey color
                    "& .MuiTableCell-root": {
                      padding: "8px",
                      wordWrap: "break-word",
                      overflowWrap: "break-word", // Adjust padding here to make cells smaller
                    },
                  },
                }}
              >
                {SimpleTableHeader("TOTAL")}
                {SimpleTableCell("")}
                {SimpleTableHeader("£" + displayTotalLineItemPrice(Attendees).toFixed(2))}
                {SimpleTableHeader("£" + sumSubAmountByAttendeeIDs(Attendees, "Net").toFixed(2))}
                {SimpleTableHeader("£" + sumSubAmountByAttendeeIDs(Attendees, "Gross").toFixed(2))}
                {SimpleTableHeader("£" + (displayTotalLineItemPrice(Attendees)*0.2).toFixed(2)+" + £" + (sumSubAmountByAttendeeIDs(Attendees, "Net")*0).toFixed(2)+" + £" + (sumSubAmountByAttendeeIDs(Attendees, "Gross")*0.2).toFixed(2))}
                {SimpleTableHeader("£" + ((displayTotalLineItemPrice(Attendees)*0.2)+(sumSubAmountByAttendeeIDs(Attendees, "Gross")*0.2)).toFixed(2))}
              </TableRow>
            {ECs.map((EC, index) => {

                let AttendeeArray = findAttendeesByECId(EC._id)
              const lineItemCommissionPre = displayTotalLineItemPrice(AttendeeArray);
              const netCommissionPre = sumSubAmountByAttendeeIDs(AttendeeArray, "Net");
              const grossCommissionPre = sumSubAmountByAttendeeIDs(AttendeeArray, "Gross");

              return (
                <TableRow
                  key={EC._id}
                  sx={{
                    "&:hover": {
                      backgroundColor: "rgba(169, 169, 169, 0.8)",
                      "& .MuiTableCell-root": {
                        padding: "8px",
                        wordWrap: "break-word",
                        overflowWrap: "break-word",
                      },
                    },
                  }}
                >
                  {SimpleTableCell(getNestedPropByID(
                    Agencies,
                    EC.MetaData?.Agency_id,
                    "Name",
                    "BasicInfo"
                  )+" / "+(EC.BasicInfo?.First_Name || "") + " " + (EC.BasicInfo?.Last_Name || ""))}
                  
                  <TableCell
      component="th"
      scope="row"
      sx={{
        padding: "8px",
        wordWrap: "break-word",
        overflowWrap: "break-word",
        backgroundColor: (EC.BankingInfo?.Account_Name && EC.BankingInfo?.Account_Name !== getNestedPropByID(
                    Agencies,
                    EC.MetaData?.Agency_id,
                    "Name",
                    "BasicInfo"
                  )) ? "rgba(255, 0, 0, 0.3)" : "", // Light red if not matching
      }}
    >
      {EC.BankingInfo?.Account_Name || ""}
    </TableCell>
                  {SimpleTableCell(EC.BasicInfo?.Email || "")}
                  {/* Sales */}
                  {SimpleTableCell(lineItemCommissionPre > 0 ? "£" + lineItemCommissionPre.toFixed(2) : "")}
                  {SimpleTableCell(netCommissionPre > 0 ? "£" + netCommissionPre.toFixed(2) : "")}
                  {SimpleTableCell(grossCommissionPre > 0 ? "£" + grossCommissionPre.toFixed(2) : "")}
                  {/* Commission */}
                  {SimpleTableCell(
                    [
                      lineItemCommissionPre > 0 ? `£${lineItemCommissionPre*0.2.toFixed(2)}` : "",
                      grossCommissionPre > 0 ? `£${grossCommissionPre*0.2.toFixed(2)}` : ""
                    ].filter(Boolean).join(" + ")
                  )}
                  {SimpleTableCell(
                    "£" + (
                      (lineItemCommissionPre > 0 ? lineItemCommissionPre*0.2 : 0) +
                      (grossCommissionPre > 0 ? grossCommissionPre*0.2 : 0)
                    ).toFixed(2)
                  )}
                  {/* //Commision2025 */}
                  <TableCell>
                    <Button variant="contained" color={EC.MetaData?.Commision2025 === "Yes" ? "success" : "primary"}
                    onClick={() => handleCommission2025Click(EC._id, EC.MetaData?.Commision2025 || "No", "Commision2025")}>
                      {EC.MetaData?.Commision2025 || "No"}
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button variant="contained" color={EC.MetaData?.Commision2025Sent === "Yes" ? "success" : "primary"}
                    onClick={() => handleCommission2025Click(EC._id, EC.MetaData?.Commision2025Sent || "No", "Commision2025Sent")}>
                      {EC.MetaData?.Commision2025Sent || "No"}
                    </Button>
                  </TableCell>
                  <TableCell>
                    <Button variant="contained" color={EC.MetaData?.Commision2025Confirmed === "Yes" ? "success" : "primary"}
                    onClick={() => handleCommission2025Click(EC._id, EC.MetaData?.Commision2025Confirmed || "No", "Commision2025Confirmed")}>
                      {EC.MetaData?.Commision2025Confirmed || "No"}
                    </Button>
                  </TableCell>

                </TableRow>
              );
})}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
      </div>
    </div>
  );
}

export default EndOfYearStaffView;
